<script lang="ts">
  import { getContext } from "svelte";

  const { close } = getContext("simple-modal");

  const openHelp = () => {
    const w = window as any;

    w.LiveChatWidget.call("maximize");
  };
</script>
<div class="stakinghelp_outer">
<h3 class="modal_heading">
  <i class="fas fa-question-circle" />
  Staking
</h3>

<div class="section">
  <p>
    <b>Staking DOE</b>
  </p>

  <ol>
    <li>Connect wallet</li>

    <li>
      Press approve to allow your DOE-ETH SLP to work with the staking contract. Please wait
      for the transaction to confirm. (If you don't see the 'Approve', button
      you are likely already approved.)
    </li>

    <li>Enter the amount you want to stake in the input box.</li>

    <li>
      Press the button labeled stake. Please wait for the transaction to
      confirm.
    </li>
  </ol>
</div>

<div class="section">
  <p>
    <b>Checking balance</b>
  </p>

  <p>
    Your stake balance should appear at the top of the staking card, labeled
    `staked`. If your staked balance appears as <code>0.0</code>, and you are
    sure you have approved and staked, try the steps below:
  </p>

  <ol>
    <li>Refresh the page (It takes some time for your balances to show up).</li>

    <li>
      Ensure the correct wallet address is connected. (Your connected wallet
      address is shown at the bottom of the staking page).
    </li>
  </ol>
</div>

<div class="section">
  <p>
    <b>Unstaking</b>
  </p>

  <ol>
    <li>
      Connect wallet
    </li>
    <li>Check you have a staked coins to withdraw (see section
        above).</li>
    <li>
      Press the `Claim & Unstake` button. Please allow some time for the
      transaction to confirm
    </li>
  </ol>
</div>

<div class="section">
  <p><b>Staking Contracts</b></p>

  <p>
    $DOE Rewards: <a class="brack_link"
      href="https://arbiscan.io/address/0x3c40601f73fbf50b81a72edbf2786f14ebb7371b"
      >0x3C40601f73fbf50b81a72edbf2786f14EBb7371b</a
    >
  </p>
</div>

<div class="section">
  <button class="btn" on:click={openHelp}>
        Need More help?
    </button>
</div>
</div>
<style>
  h3 {
    margin-top: 0px;
  }

  pre {
    background-color: var(--button-color);
    color: var(--button-text-color);
    padding: 10px;
    border-radius: var(--border-radius);
    word-wrap: break-word;
    white-space: pre-wrap;
  }

  i {
    font-size: 0.9rem;
    opacity: 0.5;
  }

  .section {
    margin-bottom: 10px;
  }
  .stakinghelp_outer .section  p{
    color:#93CDBF;
  }
  .stakinghelp_outer .section  ol li{
    color:#fff;   
  } 
  .stakinghelp_outer .section  p a{
    color:#93CDBF;
    font-weight:600;
  }
  .brack_link{
    word-break: break-word;
  }
</style>
